export default __webpack_public_path__ + "img/Blood.12d6727d.png";